export const categories = [
  { id: "dianying", name: "电影", icon: "ri-film-line", description: "院线大片、经典佳作", color: "primary" },
  { id: "dianshiju", name: "电视剧", icon: "ri-tv-line", description: "热播剧集、口碑好剧", color: "accent" },
  { id: "zongyi", name: "综艺", icon: "ri-emotion-laugh-line", description: "热门综艺、欢笑不断", color: "secondary" },
  { id: "dongman", name: "动漫", icon: "ri-ghost-line", description: "热血番剧、经典动漫", color: "primary" },
  { id: "jilupian", name: "纪录片", icon: "ri-earth-line", description: "探索世界、记录真实", color: "accent" },
  { id: "yinyue", name: "音乐", icon: "ri-music-line", description: "MV、演唱会、音乐节目", color: "secondary" },
  { id: "youxi", name: "游戏", icon: "ri-gamepad-line", description: "赛事直播、游戏解说", color: "primary" },
  { id: "zhishi", name: "知识", icon: "ri-lightbulb-line", description: "科普教育、技能学习", color: "accent" },
];

export const categoriesMap: Record<string, typeof categories[0]> = {};
categories.forEach((c) => { categoriesMap[c.id] = c; });